import Vue from "vue";
import Router from "vue-router";
import Layout from "@/layout";
// import dispatch from "./modules/dispatch";
import drivers from "./modules/driver";
import contacts from "./modules/contacts";
import document from "./modules/document";
import assets from "./modules/assets";
import setting from "./modules/setting";
import message from "./modules/message";
import error from "./modules/error";
import selfOrder from './modules/self-order';
import map from './modules/map';
import tableExample from "./modules/tableExample";
import bulletin from "./modules/bulletin";
import driverInvitation from "./modules/driver-invitation";
import accounting from "./modules/accounting";
import onboarding from './modules/onboarding';
import reactive from "./modules/reactive";
import login from './modules/login';
import common from './modules/common'
import betaAccount from './modules/beta-account'
import loads from './modules/loads';
import loadBoard from './modules/load-board'
import fromDispatch, {dashboardv2, maintenance} from './from-dispatch'
import usingAsContent from './using-as-content.js'
import {systemInfo} from "@/shared-services";
import marketInsight from './modules/market-insights'
import fuelCard from './modules/from-dispatch/fuel-card'
import carrierCompatibleRouter from './modules/carrier-compatible-router'
import intercpt from '@/router-v2/modules/intercpt'
import wallet, {Nologin as NoLoginWallet} from './modules/wallet'

Vue.use(Router);

const originalPush = Router.prototype.push
Router.prototype.push = function push(location, resolve, reject) {
  if (resolve || reject) {
    return originalPush.call(this, location, resolve, reject)
  }
  return originalPush.call(this, location).catch(error => error)
}

/**
 * hidden: true                   if set true, item will not show in the sidebar(default is false)
 * alwaysShow: true               if set true, will always show the root menu
 * keepName: 'Component name'     If you want to cache the current page, in addition to adding "keepAlive: ture", you must also add your component name
 * disabled: true                 if set to true, routing is forbidden to jump(default is false)
 */

export const constantRoutes = systemInfo.isCommand ? [
    fuelCard,
    dashboardv2,
    map,
    loadBoard,
    marketInsight,
    intercpt,
    NoLoginWallet,
    {
      path: "/sign-up",
      name: "signUp",
      hidden: true,
      component: () =>
        import(/* webpackChunkName: "register-view" */ "@/views/login-v2/register-view/index"),
    }, {
      path: "/sso-checking",
      name: "ssoChecking",
      hidden: true,
      component: () =>
        import(/* webpackChunkName: "register-view" */ "@/views/sso-checking/index"),
    },
    {
      path: "/first-order",
      name: "firstOrder",
      hidden: true,
      component: () =>
        import(/* webpackChunkName: "first-order" */ "@/views/first-order"),
    },
    {
      path: "/first-order2",
      name: "firstOrder2",
      hidden: true,
      component: () => import("@/views/first-order2"),
    },
    {
      path: "/share/:id",
      name: "loadsShare",
      hidden: true,
      component: () => import('@/views/dispatchs-v2')
    },
    {
      path: "/scan-document",
      name: "scanDocument",
      hidden: true,
      component: () => import(/* webpackChunkName: "scan-document" */ "@/views/scan-document")
    },
    {
      path: "/shareTrack",
      name: "shareTrack",
      hidden: true,
      component: () => import(/* webpackChunkName: "scan-document" */ "@/views/share-tracking")
    },
    {
      path: "/feedback",
      name: "feedback",
      hidden: true,
      component: () => import("@/views/feedback")
    },
    {
      path: "/signature/t/:token",
      name: 'signatureToken',
      hidden: true,
      component: () => import("@/views/signature/t.vue")
    },
    ...login,
    ...error,
    ...driverInvitation,
    ...process.env.NODE_ENV !== 'production' ? [
      {
        path: "/svg-map",
        hidden: true,
        component: () => import("@/views/svg-map")
      },
      common
    ] : []
  ] : usingAsContent;

export const asyncRoutes = systemInfo.isCommand ? [
  {
    path: "/",
    component: Layout,
    redirect: "/dashboard",
    hidden:true,
    children: [
      {
        path: "dashboard",
        name: "dashboard",
        component: () => import(/* webpackChunkName: "login-dashboard" */ "@/views/dashboard"),
        meta: {title: "Dashboard", icon: "dashboard-v2"},
      },
    ]
  },
  // map,
  // schedule,
  // loadBoard,
  // marketInsight,
  loads,
  {
    path: "/import",
    name: "dispatchImport",
    component: Layout,
    redirect: '/import/index',
    hidden: true,
    children: [
      {
        path: 'index',
        name: 'importindex',
        component: () => import(/* webpackChunkName: "dispatch-import" */ "@/views/dispatchs/dispatch/import"),
        meta: { activeMenu: '/load'},
      }
    ]
  },
  // searchLoad,
  // dispatch,
  drivers,
  contacts,
  document,
  accounting,
  wallet,
  assets,
  message,
  maintenance,
  bulletin,
  setting,
  selfOrder,
  // dispatch,
  onboarding,
  reactive,
  betaAccount,
  carrierCompatibleRouter,
  process.env.NODE_ENV !== "production" ||
  process.env.VUE_APP_RUNTIME_ENV === "qa"
    ? tableExample
    : { path: "", hidden: true, meta: { title: "", icon: "" } },
  // * router must be placed at the end !!!
  ...fromDispatch,
  ...systemInfo.isCommand ? [{
    path: "*",
    component: () =>
      import(/* webpackChunkName: "basic" */ "@/views/error-page"),
    hidden: true,
  }]: []
] : [];

// vue-router3.*自带路由正则，通过正则判断是否存在某个路由，以此判断404和401
export const fullyRouted = new Router({
  mode: "history",
  routes: constantRoutes,
});

export default new Router({
  mode: "history",
  routes: constantRoutes,
});
